import React, { Component } from "react";
import * as Constants from "../../Constants/index";
import axios from "axios";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import Pagination from "react-js-pagination";
import swal from "sweetalert";
import CreateOrders from "./createOrders.component";
import Modal from "react-modal";
import ResponsivePagination from "react-responsive-pagination";

class Orders extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.fileInputRef = React.createRef();
  }

  state = {
    name: "",
    sortBy: "name",
    limit: 30,
    totalResults: 0,
    page: 1,
    members: [],
    search: "",
    create: 0,
    view: 0,
    verifyStatus: false,
    partialModalOpen: false,
    partialItems: [],
    status: "",
    orderID: "",
    staus: "",
    remark: "",
    type: "",
    selectedFile: null,
    uploadStatus: "",
    fileError: "",
    selectedMember: null,
    userTypeLogin: "",
    userTypePhoneNumber: "",
    remarkError: false,
    transId: "",
    orderTypeData: "",
    // Modal state
    modalOpen: false,
    modalImageUrl: "",
    modalImageLabel: "",
  };

  componentDidMount() {
    const userTypeData = localStorage.getItem("usertype");
    const userTypeMobile = localStorage.getItem("usermobile");
    const currentURL = window.location.pathname;
    const parts = currentURL.split("/");
    let programid = parts.pop();
    programid = parseInt(programid);
    const pathSegments = window.location.pathname.split("/");
    let compid = pathSegments[pathSegments.length - 2];
    const SALESRequest = async () => {
      try {
        const token = localStorage.getItem("token");

        let params = {
          sortAsc: true,
          sortBy: this.state.sortBy,
          limit: this.state.limit,
          page: this.state.page,
        };

        if (this.state.search) {
          params.searchTerm = this.state.search;
        }

        if (this.state.type) {
          params.status = this.state.type;
        }
        if (this.state.orderTypeData) {
          params.orderType = this.state.orderTypeData;
        }

        const resp = await axios.get(
          Constants.api + "redeem/catelog/orderAll",
          {
            params,
            headers: {
              Authorization: `Bearer ${token}`,
              company: 0,
              program: 0,
              appVersion: Constants.av,
              platform: Constants.pt,
            },
          }
        );

        if (resp.status === 201 && resp.data.result !== "error") {
          this.setState({
            members: resp.data.output.results,
            totalResults: resp.data.output.totalResults,
            userTypeLogin: userTypeData,
            userTypePhoneNumber: userTypeMobile,
          });
        } else if (resp.status === 403) {
          localStorage.clear();
          window.location.href = "/";
        }
      } catch (err) {
        console.error(err);
      }
    };

    SALESRequest();
  }

  handleInputChangeFilter = (event) => {
    const { name, value } = event.target;

    this.setState(
      {
        [name]: value,
        page: 1,
      },
      this.componentDidMount
    );
  };

  allowedFileExtensions = [".csv", ".xls", ".xlsx"];

  validateSelectedFile = (selectedFile) => {
    if (!selectedFile) {
      return "Please select a file first.";
    }

    const fileName = selectedFile.name ? selectedFile.name.toLowerCase() : "";
    const isValidExtension = this.allowedFileExtensions.some((extension) =>
      fileName.endsWith(extension)
    );

    if (!isValidExtension) {
      return "Please upload only .csv, .xls, or .xlsx files.";
    }

    return "";
  };

  handleFileChange = (event) => {
    const selectedFile = event.target.files[0] || null;
    const fileError = this.validateSelectedFile(selectedFile);
    this.setState({
      selectedFile: fileError ? null : selectedFile,
      uploadStatus: fileError ? "" : selectedFile ? selectedFile.name : "",
      fileError,
    });

    if (fileError && this.fileInputRef.current) {
      this.fileInputRef.current.value = "";
    }
  };

  handleFileUpload = async () => {
    const { selectedFile } = this.state;
    const token = localStorage.getItem("token");
    const fileError = this.validateSelectedFile(selectedFile);

    if (fileError) {
      this.setState({
        uploadStatus: fileError,
        fileError,
      });
      swal({
        title: "Error",
        text: fileError,
        icon: "warning",
        timer: 2000,
        buttons: false,
        timerProgressBar: true,
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axios.post(
        Constants.api + "redeem/catelog/redeem_order_status_uploader",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("language"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: 1,
            program: 1,
          },
        }
      );

      if (response.data.code === 10001) {
        this.setState({
          selectedFile: null,
          uploadStatus: "Upload successful.",
          fileError: "",
        });
        if (this.fileInputRef.current) {
          this.fileInputRef.current.value = "";
        }
        swal({
          title: "Success",
          text: "Upload successful.",
          icon: "success",
          timer: 2000,
          buttons: false,
          timerProgressBar: true,
        });
        this.componentDidMount();
      } else if (response.data.code === 12002) {
        this.setState({ uploadStatus: "Upload failed.", fileError: "" });
        swal({
          title: "Error",
          text: "Upload failed.",
          icon: "error",
          timer: 2000,
          buttons: false,
          timerProgressBar: true,
        });
      } else {
        this.setState({
          uploadStatus: "Unexpected response from server.",
          fileError: "",
        });
        swal({
          title: "Warning",
          text: "Unexpected response from server.",
          icon: "warning",
          timer: 2000,
          buttons: false,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      this.setState({
        uploadStatus: `Upload failed: ${errorMessage}`,
        fileError: "",
      });
      swal({
        title: "Error",
        text: `Upload failed: ${errorMessage}`,
        icon: "error",
        timer: 2000,
        buttons: false,
        timerProgressBar: true,
      });
    }
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "transId") {
      this.setState({ transId: this.sanitizeTransId(value) });
      return;
    }

    if (name === "status") {
      this.setState({
        status: value,
        transId: value === "DELIVERED" ? this.state.transId : "",
      });
      return;
    }

    if (name === "remark") {
      if (value.length <= 255) {
        this.setState({
          remark: value,
          remarkError: false,
        });
      } else {
        this.setState({
          remarkError: true,
        });
      }
      return;
    }

    this.setState({ [name]: value });
  };

  searchHandleChange = (event) => {
    this.setState(
      { search: event.target.value, page: 1 },
      this.componentDidMount
    );
  };

  handlePageChange(pageNumber) {
    console.log(`active page is ${pageNumber}`);
    this.setState({ page: pageNumber }, this.componentDidMount);
  }

  closeVerifyModal = () => {
    this.setState({
      verifyStatus: false,
      orderID: "",
      status: "",
      remark: "",
      transId: "",
      selectedMember: null,
      remarkError: false,
    });
  };

  closePartialModal = () => {
    this.setState({
      partialModalOpen: false,
      selectedMember: null,
      partialItems: [],
    });
  };

  sanitizeTransId = (value) => value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 40);

  isFinalizedPartialItem = (status) =>
    status === "DELIVERED" || status === "CANCELLED";

  handlePartialItemChange = (index, field, value) => {
    this.setState((prevState) => ({
      partialItems: prevState.partialItems.map((item, itemIndex) => {
        if (itemIndex !== index) {
          return item;
        }

        if (this.isFinalizedPartialItem(item.originalStatus)) {
          return item;
        }

        if (field === "remark") {
          if (value.length > 255) {
            return {
              ...item,
              remarkError: true,
            };
          }

          return {
            ...item,
            remark: value,
            remarkError: false,
          };
        }

        if (field === "transId") {
          return {
            ...item,
            transId: this.sanitizeTransId(value),
            transIdError: false,
          };
        }

        return {
          ...item,
          [field]: value,
          ...(field === "status"
            ? {
              statusError: false,
              transId: value === "DELIVERED" ? item.transId : "",
              transIdError: false,
            }
            : {}),
        };
      }),
    }));
  };

  savePartialItems = () => {
    let hasErrors = false;

    const validatedItems = this.state.partialItems.map((item) => {
      const statusError = !item.status;
      const remarkError =
        item.status === "CANCELLED"
          ? !item.remark || item.remark.length > 255
          : item.remark.length > 255;
      const transIdError = item.status === "DELIVERED" && !item.transId;

      if (statusError || remarkError || transIdError) {
        hasErrors = true;
      }

      return {
        ...item,
        statusError,
        remarkError,
        transIdError,
      };
    });

    this.setState({ partialItems: validatedItems });

    if (hasErrors) {
      swal({
        title: "Error",
        text: "Please complete all partial item fields before saving.",
        icon: "warning",
        timer: 2000,
        buttons: false,
      });
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const currentURL = window.location.pathname;
      const parts = currentURL.split("/");
      let programid = parts.pop();
      programid = parseInt(programid);

      // FIX: null-safe access to selectedMember.id
      const selectedMemberId = this.state.selectedMember?.id ?? "";

      const payload = {
        status: "",
        remark: "",
        transId: "",
        items: validatedItems.map((item) => ({
          orderItemId: item.orderItemId,
          status: item.status,
          remark: item.remark,
          transId: item.transId || "",
        })),
      };

      axios
        .post(
          Constants.api +
          "redeem/catelog/update/order/status/" +
          selectedMemberId,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              program: programid,
              "Accept-Language": localStorage.getItem("language"),
              appVersion: Constants.av,
              platform: Constants.pt,
            },
          }
        )
        .then(() => {
          swal("Status Updated");
          this.setState(
            {
              partialModalOpen: false,
              selectedMember: null,
              partialItems: [],
            },
            () => {
              this.componentDidMount();
            }
          );
        })
        .catch(() => { });
    } catch (err) {
      console.error(err);
    }
  };

  // Modal helpers
  openImageModal = (url, label) => {
    this.setState({
      modalOpen: true,
      modalImageUrl: url || "",
      modalImageLabel: label || "",
    });
  };

  closeImageModal = () => {
    this.setState({ modalOpen: false, modalImageUrl: "", modalImageLabel: "" });
  };

  render() {
    const { selectedFile, uploadStatus, fileError } = this.state;
    const sampleFileUrl = `${process.env.PUBLIC_URL || ""
      }/redeem_order_status_uploader_sample.csv`;

    // FIX: null-safe points calculation
    const selectedMemberPoints =
      this.state.selectedMember?.points != null
        ? Number(this.state.selectedMember.points).toFixed(2)
        : "0.00";

    let verifyStatus = (id, status, remark, memberNumber) => {
      this.setState({
        verifyStatus: true,
        orderID: id ?? "",
        status,
        remark: remark || "",
        transId: "",
        selectedMember: memberNumber,
        remarkError: false,
      });
    };

    const editItem = (id) => {
      // FIX: guard against null id
      if (id == null) return;
      try {
        const token = localStorage.getItem("token");
        const deletedata = new FormData();
        deletedata.append("id", id);

        axios
          .get(
            Constants.api + "redeem/catelog/orderAll/" + id,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Accept-Language": localStorage.getItem("language"),
              },
            },
            deletedata
          )
          .then((resp) => {
            if (resp.status == 200) {
              this.setState({ create: 1, resp: resp });
            } else if (resp.status == 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
            }
          })
          .catch((err) => { });
      } catch (err) {
        console.error(err);
      }
    };

    const changeStatus = (id) => {
      // FIX: guard against null id
      if (id == null) {
        swal({
          title: "Error",
          text: "Invalid order ID.",
          icon: "warning",
          timer: 2000,
          buttons: false,
        });
        return;
      }
      try {
        if (!this.state.status) {
          swal({
            title: "Error",
            text: "Please select a status before saving.",
            icon: "warning",
            timer: 2000,
            buttons: false,
          });
          return;
        }
        if (this.state.status === "DELIVERED" && !this.state.transId) {
          swal({
            title: "Error",
            text: "Please enter Trans-ID for delivered orders.",
            icon: "warning",
            timer: 2000,
            buttons: false,
          });
          return;
        }
        if (this.state.status === "CANCELLED" && !this.state.remark) {
          swal({
            title: "Error",
            text: "Please enter remark for cancelled order.",
            icon: "warning",
            timer: 2000,
            buttons: false,
          });
          return;
        }

        const token = localStorage.getItem("token");
        const currentURL = window.location.pathname;

        const parts = currentURL.split("/");
        let programid = parts.pop();

        programid = parseInt(programid);
        axios
          .post(
            Constants.api + "redeem/catelog/update/order/status/" + id,
            {
              status: this.state.status,
              remark: this.state.remark,
              transId: this.state.transId,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                program: programid,
                "Accept-Language": localStorage.getItem("language"),
                appVersion: Constants.av,
                platform: Constants.pt,
              },
            }
          )
          .then((resp) => {
            swal("Status Updated");
            this.setState(
              {
                verifyStatus: false,
                orderID: "",
                status: "",
                remark: "",
                transId: "",
                selectedMember: null,
                remarkError: false,
              },
              () => {
                this.componentDidMount();
              }
            );
          })
          .catch((err) => { });
      } catch (err) {
        console.error(err);
      }
    };

    const viewItem = (id) => {
      // FIX: guard against null id
      if (id == null) return;
      try {
        const token = localStorage.getItem("token");
        const deletedata = new FormData();
        deletedata.append("id", id);

        axios
          .get(
            Constants.api + "redeem/catelog/orderAll/" + id,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Accept-Language": localStorage.getItem("language"),
              },
            },
            deletedata
          )
          .then((resp) => {
            if (resp.status == 200) {
              this.setState({ view: 1, create: 1, resp: resp });
            } else if (resp.status == 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
            }
          })
          .catch((err) => { });
      } catch (err) {
        console.error(err);
      }
    };

    const deleteItem = (id) => {
      // FIX: guard against null id
      if (id == null) return;
      if (window.confirm("Are you sure?")) {
        try {
          const token = localStorage.getItem("token");
          const deletedata = new FormData();
          deletedata.append("id", id);

          axios
            .delete(Constants.api + "redeem/catelog/orderAll/" + id, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Accept-Language": localStorage.getItem("language"),
              },
            })
            .then((resp) => {
              if (resp.status == 200) {
                this.componentDidMount();
              } else if (resp.status == 403) {
                localStorage.clear();
                window.location.href = "/";
              } else {
              }
            });
        } catch (err) {
          console.error(err);
        }
      }
    };

    const handlePartialAction = (item) => {
      // FIX: null-safe orderItems mapping
      const orderItems = Array.isArray(item?.orderItems) ? item.orderItems : [];
      this.setState({
        partialModalOpen: true,
        selectedMember: item,
        partialItems: orderItems.map((orderItem, index) => ({
          index,
          // FIX: null-safe id resolution
          orderItemId:
            orderItem?.id ?? orderItem?.orderItemId ?? 0,
          originalStatus: orderItem?.status ?? "",
          status: orderItem?.status ?? "",
          remark: orderItem?.remark ?? "",
          transId: orderItem?.transId ?? "",
          statusError: false,
          remarkError: false,
          transIdError: false,
          quantity: orderItem?.quantity ?? 0,
          points: orderItem?.points ?? 0,
          // FIX: null-safe nested product access
          imageURL: orderItem?.product?.imageURL ?? "",
          productName: orderItem?.product?.name ?? "Product",
        })),
      });
    };

    const membersRender = this.state.members.map((item, i) => {
      // FIX: null-safe orderItems array
      const orderItems = Array.isArray(item?.orderItems) ? item.orderItems : [];

      return (
        <React.Fragment key={item?.id ?? i}>
          <tr>
            <td>
              {/* FIX: display dash when id is null */}
              <p>{item?.id ?? "-"}</p>
            </td>
            <td>
              <p>{item?.name ?? "-"}</p>
            </td>
            <td>
              <p>{item?.mobile ?? "-"}</p>
            </td>
            <td>
              {/* FIX: null-safe points */}
              <p>{item?.points != null ? Number(item.points).toFixed(2) : "0.00"}</p>
            </td>
            <td>
              {/* FIX: null-safe totalPoints */}
              <p>
                {item?.totalPoints != null
                  ? Number(item.totalPoints).toFixed(2)
                  : "0.00"}
              </p>
            </td>
            <td>
              <p>{item?.status ?? "-"}</p>
            </td>
            <td>
              <p>{item?.orderType ?? "-"}</p>
            </td>
            <td>
              <p>
                {orderItems.map((j, idx) => {
                  // FIX: null-safe product access inside orderItems
                  const productName = j?.product?.name ?? "Unknown Product";
                  const imageURL = j?.product?.imageURL ?? "";
                  const quantity = j?.quantity ?? 0;
                  const points = j?.points ?? 0;

                  return (
                    <React.Fragment key={j?.id ?? idx}>
                      <button
                        type="button"
                        className="btn btn-sm"
                        style={{
                          backgroundColor: "#58B05C",
                          color: "white",
                          marginRight: "6px",
                        }}
                        onClick={() =>
                          this.openImageModal(imageURL, productName)
                        }
                      >
                        View
                      </button>
                      {productName} * {quantity} ({points} Points)
                      <br />
                    </React.Fragment>
                  );
                })}
              </p>
            </td>

            <td className="date_two">{item?.createDateTime ?? "-"}</td>

            <td>
              {item?.status !== "CANCELLED" &&
                item?.status !== "DELIVERED" &&
                item?.status !== "PARTIAL" ? (
                <button
                  className="btn btn-outline-primary btn-sm"
                  onClick={() =>
                    verifyStatus(item?.id, item?.status, item?.remark, item)
                  }
                >
                  <i className="material-icons text-lg">visibility</i> Change
                  Status
                </button>
              ) : (
                <button
                  disabled={true}
                  className="btn btn-outline-primary btn-sm"
                  onClick={() =>
                    verifyStatus(item?.id, item?.status, item?.remark, item)
                  }
                >
                  <i className="material-icons text-lg">visibility</i> Change
                  Status
                </button>
              )}
              {item?.orderType === "CATALOG" && orderItems.length > 1 ? (
                <>
                  &nbsp;
                  <button
                    className="btn btn-outline-warning btn-sm"
                    disabled={
                      item?.status === "CANCELLED" ||
                      item?.status === "DELIVERED"
                    }
                    onClick={() => handlePartialAction(item)}
                  >
                    <i className="material-icons text-lg">pending</i> Partial
                  </button>
                </>
              ) : null}
            </td>
          </tr>
        </React.Fragment>
      );
    });

    return (
      <>
        {/* ── Image Preview Modal ── */}
        {this.state.modalOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0,0,0,0.7)",
              zIndex: 99999999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={this.closeImageModal}
          >
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                padding: "20px",
                maxWidth: "90vw",
                maxHeight: "90vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                boxShadow: "0 4px 32px rgba(0,0,0,0.4)",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                <h5 style={{ margin: 0 }}>{this.state.modalImageLabel}</h5>
                <button
                  type="button"
                  onClick={this.closeImageModal}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "22px",
                    cursor: "pointer",
                    lineHeight: 1,
                    color: "#555",
                  }}
                  aria-label="Close"
                >
                  &times;
                </button>
              </div>
              {/* FIX: only render img when URL is non-empty */}
              {this.state.modalImageUrl ? (
                <img
                  src={this.state.modalImageUrl}
                  alt={this.state.modalImageLabel || "Product Image"}
                  style={{
                    maxWidth: "80vw",
                    maxHeight: "75vh",
                    objectFit: "contain",
                    borderRadius: "4px",
                  }}
                />
              ) : (
                <div
                  style={{
                    width: "200px",
                    height: "200px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f3f4f6",
                    borderRadius: "4px",
                    color: "#9ca3af",
                    fontSize: "14px",
                  }}
                >
                  No Image Available
                </div>
              )}
            </div>
          </div>
        )}

        {this.state.partialModalOpen && this.state.selectedMember && (
          <Modal
            isOpen={this.state.partialModalOpen}
            onRequestClose={this.closePartialModal}
            className="custom-modal"
            overlayClassName="custom-modal-overlay"
          >
            <button
              onClick={this.closePartialModal}
              type="button"
              className="btn-close btn bg-gradient-primary"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              x
            </button>

            <div
              className="mx-4 my-3"
              style={{
                maxHeight: "80vh",
                overflowY: "auto",
                overflowX: "hidden",
                paddingRight: "6px",
              }}
            >
              <div className="mb-3">
                <h5 className="mb-0">Partial</h5>
              </div>
              <div
                className="p-3"
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: "10px",
                  backgroundColor: "#fafbfc",
                  textAlign: "left",
                }}
              >
                <div className="mb-3">
                  <p
                    className="mb-1"
                    style={{
                      fontSize: "12px",
                      fontWeight: "700",
                      color: "#6b7280",
                      textTransform: "uppercase",
                      letterSpacing: "0.04em",
                    }}
                  >
                    Points
                  </p>
                  <p
                    className="mb-0"
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "#1f2937",
                    }}
                  >
                    {selectedMemberPoints}
                  </p>
                </div>

                {this.state.partialItems?.length ? (
                  <div>
                    <p
                      className="mb-2"
                      style={{
                        fontSize: "12px",
                        fontWeight: "700",
                        color: "#6b7280",
                        textTransform: "uppercase",
                        letterSpacing: "0.04em",
                      }}
                    >
                      Order Items
                    </p>
                    {this.state.partialItems.map((orderItem, index) => {
                      const isFinalizedRow = this.isFinalizedPartialItem(
                        orderItem.originalStatus
                      );

                      return (
                        <div
                          key={`${orderItem?.productName ?? "item"}-${index}`}
                          className="mb-3"
                          style={{
                            paddingBottom: "12px",
                            paddingTop: "12px",
                            borderBottom:
                              index !== this.state.partialItems.length - 1
                                ? "1px solid #eceff3"
                                : "none",
                            marginBottom:
                              index !== this.state.partialItems.length - 1
                                ? "12px"
                                : "0",
                            opacity: isFinalizedRow ? 0.85 : 1,
                          }}
                        >
                          <div
                            className="d-flex align-items-center mb-3"
                            style={{ gap: "12px" }}
                          >
                            {orderItem?.imageURL ? (
                              <button
                                type="button"
                                className="btn btn-sm mb-0"
                                style={{
                                  backgroundColor: "#58B05C",
                                  color: "white",
                                  minWidth: "64px",
                                }}
                                onClick={() =>
                                  this.openImageModal(
                                    orderItem.imageURL,
                                    orderItem?.productName ?? "Product"
                                  )
                                }
                              >
                                View
                              </button>
                            ) : (
                              <div
                                className="d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "64px",
                                  height: "32px",
                                  borderRadius: "8px",
                                  backgroundColor: "#eef2f7",
                                  color: "#94a3b8",
                                  border: "1px solid #dbe3ea",
                                  fontSize: "12px",
                                  padding: "0 10px",
                                }}
                              >
                                No Image
                              </div>
                            )}
                            <div style={{ flex: 1 }}>
                              <p
                                className="mb-1"
                                style={{ fontWeight: "600", color: "#1f2937" }}
                              >
                                {orderItem?.productName ?? "Product"}
                              </p>
                              <p
                                className="mb-1"
                                style={{ fontSize: "13px", color: "#6b7280" }}
                              >
                                {/* FIX: null-safe orderItemId display */}
                                Order Item ID: {orderItem?.orderItemId ?? "-"}
                              </p>
                              <p
                                className="mb-0"
                                style={{ fontSize: "13px", color: "#6b7280" }}
                              >
                                Qty: {orderItem?.quantity ?? 0} | Points:{" "}
                                {orderItem?.points ?? 0}
                              </p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm-12">
                              <div className="mx-1 input-group-outline my-2">
                                Status
                              </div>
                              <div className="mx-1 input-group-outline my-2">
                                <select
                                  value={orderItem.status}
                                  className="form-control"
                                  disabled={isFinalizedRow}
                                  style={{ height: "50px" }}
                                  onChange={(e) =>
                                    this.handlePartialItemChange(
                                      index,
                                      "status",
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="DELIVERED">DELIVERED</option>
                                  <option value="INPROCESS">INPROCESS</option>
                                  <option value="CANCELLED">CANCELLED</option>
                                </select>
                              </div>
                              {orderItem.statusError ? (
                                <p className="small text-danger mx-1 mb-0">
                                  Status is required.
                                </p>
                              ) : null}
                            </div>
                            {orderItem.status === "DELIVERED" ? (
                              <>
                                <div className="col-sm-12">
                                  <div className="mx-1 input-group-outline my-2">
                                    Trans-ID
                                  </div>
                                  <div className="mx-1 input-group-outline my-2">
                                    <input
                                      className="form-control"
                                      value={orderItem.transId}
                                      type="text"
                                      style={{ height: "50px" }}
                                      placeholder="Enter Trans-ID"
                                      disabled={isFinalizedRow}
                                      onChange={(e) =>
                                        this.handlePartialItemChange(
                                          index,
                                          "transId",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                  {orderItem.transIdError ? (
                                    <p className="small text-danger mx-1 mb-0">
                                      Trans-ID is required for delivered items.
                                    </p>
                                  ) : null}
                                </div>
                              </>
                            ) : null}
                            <div className="col-sm-12">
                              <div className="mx-1 input-group-outline my-2">
                                Remarks
                              </div>
                              <div className="mx-1 input-group-outline my-2">
                                <input
                                  className="form-control"
                                  value={orderItem.remark}
                                  maxLength={255}
                                  disabled={isFinalizedRow}
                                  style={{ height: "50px" }}
                                  onChange={(e) =>
                                    this.handlePartialItemChange(
                                      index,
                                      "remark",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                              {orderItem.remarkError ? (
                                <p className="small text-danger mx-1 mb-0">
                                  Remarks are required and must be within 255
                                  characters.
                                </p>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : null}
              </div>
              <div className="text-center mt-3">
                {(() => {
                  // hide only after saved data comes back from API / originalStatus updated
                  const hideSaveButton = this.state.partialItems.every(
                    (item) =>
                      item.originalStatus === "DELIVERED" ||
                      item.originalStatus === "CANCELLED"
                  );

                  return !hideSaveButton ? (
                    <button
                      type="button"
                      className="btn bg-gradient-primary mb-2"
                      onClick={this.savePartialItems}
                    >
                      Save Status
                    </button>
                  ) : null;
                })()}
              </div>
            </div>
          </Modal>
        )}

        {this.state.create == 0 ? (
          <>
            <main className="">
              <nav
                className="navbar navbar-main navbar-expand-lg position-sticky mt-4 top-1 px-0 mx-4 shadow-none border-radius-xl z-index-sticky"
                id="navbarBlur"
                data-scroll="true"
              >
                <div className="container-fluid py-1 px-3">
                  <nav aria-label="breadcrumb"></nav>
                  <div
                    className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4"
                    id="navbar"
                  >
                    <nav aria-label="breadcrumb">
                      <ul className="navbar-nav  justify-content-end">
                        <li className="nav-item">
                          <div className="from_dropdown">
                            <label htmlFor="show">Status</label>
                            <select
                              className="form-control"
                              value={this.state.type}
                              name="type"
                              id="show"
                              onChange={this.handleInputChangeFilter}
                            >
                              <option value="">All</option>
                              <option value="DELIVERED">DELIVERED</option>
                              <option value="ORDERED">ORDERED</option>
                              <option value="PENDING">PENDING</option>
                              <option value="INPROCESS">INPROCESS</option>
                              <option value="CANCELLED">CANCELLED</option>
                            </select>
                          </div>
                        </li>
                        <li className="nav-item" style={{ marginLeft: "10px" }}>
                          <div className="from_dropdown">
                            <label htmlFor="orderTypeSelect">Order Type</label>
                            <select
                              className="form-control"
                              value={this.state.orderTypeData}
                              name="orderTypeData"
                              id="orderTypeSelect"
                              onChange={this.handleInputChangeFilter}
                            >
                              <option value="">All</option>
                              <option value="CATALOG">CATALOG</option>
                              <option value="UPI">UPI</option>
                              <option value="BANK">BANK</option>
                              {/* <option value="PARTIAL">PARTIAL</option> */}
                            </select>
                          </div>
                        </li>
                      </ul>
                    </nav>
                    <div className="ms-md-auto pe-md-3 d-flex align-items-center">
                      <div className="input-group input-group-outline">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search"
                          onChange={this.searchHandleChange}
                        />
                      </div>
                    </div>
                    <ul className="navbar-nav justify-content-end">
                      <li className="nav-item">
                        <div className="from_dropdown">
                          <label htmlFor="showEntries">Show entries</label>

                          <select
                            id="showEntries"
                            className="form-control"
                            value={this.state.limit}
                            onChange={(e) => {
                              const value = Number(e.target.value);
                              this.setState({ limit: value, page: 1 }, () => {
                                this.componentDidMount();
                              });
                            }}
                          >
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={75}>75</option>
                            <option value={100}>100</option>
                          </select>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
              <div className="container-fluid py-4">
                <div className="row">
                  <div className="col-12">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-12">
                            <label htmlFor="redeem-order-status-upload">
                              Select File
                            </label>
                            <div className="d-flex flex-wrap align-items-end gap-2">
                              <input
                                id="redeem-order-status-upload"
                                ref={this.fileInputRef}
                                type="file"
                                accept=".xlsx,.xls,.csv"
                                className="form-control"
                                onChange={this.handleFileChange}
                                style={{ maxWidth: "320px", minWidth: "260px" }}
                              />
                              <button
                                type="button"
                                style={{
                                  backgroundColor: "#007FC7",
                                  color: "white",
                                }}
                                className="btn mb-0"
                                onClick={this.handleFileUpload}
                              >
                                Upload
                              </button>
                              <a
                                href={sampleFileUrl}
                                download="redeem_order_status_uploader_sample.csv"
                                className="btn btn-outline-primary mb-0"
                              >
                                Download Sample
                              </a>
                            </div>
                            {fileError ? (
                              <p className="small text-danger mt-2 mb-0">
                                {fileError}
                              </p>
                            ) : null}
                            <div className="mt-3">
                              <span className="small text-muted">
                                {uploadStatus ||
                                  (selectedFile
                                    ? selectedFile.name
                                    : "Select a file to upload")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header pb-0">
                        <div className="d-lg-flex justify-content-between">
                          <div>
                            <h5 className="mb-0"> Redeem Orders</h5>
                          </div>

                          {this.state.verifyStatus ? (
                            <>
                              <Modal
                                isOpen={this.state.verifyStatus}
                                onRequestClose={this.closeVerifyModal}
                                className="custom-modal"
                                overlayClassName="custom-modal-overlay"
                              >
                                <button
                                  onClick={this.closeVerifyModal}
                                  type="button"
                                  className="btn-close btn bg-gradient-primary"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                >
                                  x
                                </button>

                                <center>
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className=" mx-4 input-group-outline my-2">
                                        Status
                                      </div>

                                      <div className=" mx-4 input-group-outline my-2">
                                        <select
                                          value={this.state.status}
                                          name="status"
                                          className="form-control"
                                          onChange={(e) =>
                                            this.handleInputChange(e)
                                          }
                                        >
                                          <option value="">Select</option>
                                          <option value="DELIVERED">
                                            DELIVERED
                                          </option>
                                          <option value="ORDERED">
                                            ORDERED
                                          </option>
                                          <option value="PENDING">
                                            PENDING
                                          </option>
                                          <option value="INPROCESS">
                                            INPROCESS
                                          </option>
                                          {localStorage
                                            .getItem("usermobile")
                                            ?.trim() === "9165793896" && (
                                              <option value="CANCELLED">
                                                CANCELLED
                                              </option>
                                            )}
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  {this.state.status === "DELIVERED" && (
                                    <div className="row">
                                      <div className="col-sm-12">
                                        <div className="mx-4 input-group-outline my-2">
                                          Trans-ID
                                        </div>
                                        <div className="mx-4 input-group-outline my-2">
                                          <input
                                            className="form-control"
                                            name="transId"
                                            onChange={this.handleInputChange}
                                            value={this.state.transId}
                                            type="text"
                                            placeholder="Enter Trans-ID"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className=" mx-4 input-group-outline my-2">
                                        Remarks
                                      </div>
                                      <div className=" mx-4 input-group-outline my-2">
                                        <input
                                          className="form-control"
                                          name="remark"
                                          onChange={(e) =>
                                            this.handleInputChange(e)
                                          }
                                          value={this.state.remark}
                                          maxLength={255}
                                        />
                                      </div>
                                      {this.state.remarkError && (
                                        <p className="small text-danger">
                                          Remarks should be 255 characters only.
                                        </p>
                                      )}
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col-sm-12">
                                      <a
                                        href="#!"
                                        className="btn bg-gradient-primary mb-2"
                                        onClick={() =>
                                          changeStatus(this.state.orderID)
                                        }
                                      >
                                        {" "}
                                        Save Status
                                      </a>
                                    </div>
                                  </div>
                                </center>
                              </Modal>
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                      <div className="card-body px-0 pb-0">
                        <div className="table-responsive">
                          <table
                            className="table table-flush"
                            style={{ textAlign: "center" }}
                          >
                            <thead className="thead-light">
                              <tr>
                                <th>Order ID</th>
                                <th>Member Name</th>
                                <th>Member Mobile</th>
                                <th>Points</th>
                                <th>Total Points</th>
                                <th>Status</th>
                                <th>Redemption Type</th>
                                <th>Order Items </th>
                                <th>Created On</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>{membersRender}</tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
            <div className="pagination-container">
              <Pagination
                activePage={this.state.page}
                itemsCountPerPage={this.state.limit}
                totalItemsCount={this.state.totalResults}
                pageRangeDisplayed={10}
                onChange={this.handlePageChange.bind(this)}
              />
            </div>
          </>
        ) : this.state.resp ? (
          <CreateOrders resp={this.state.resp} />
        ) : (
          <CreateOrders />
        )}
      </>
    );
  }
}

export default Orders;